__turbopack_context__.v({
  "ButtonReset": "J8hOXG_ButtonReset",
  "Expander": "J8hOXG_Expander",
  "Filmography": "J8hOXG_Filmography",
  "IsExpanded": "J8hOXG_IsExpanded",
  "IsShowingAll": "J8hOXG_IsShowingAll",
  "Link": "J8hOXG_Link",
  "Movie": "J8hOXG_Movie",
  "MovieRole": "J8hOXG_MovieRole",
  "MovieYear": "J8hOXG_MovieYear",
  "MoviesCollapsible": "J8hOXG_MoviesCollapsible",
  "MoviesWithRole": "J8hOXG_MoviesWithRole",
  "ShowAllButton": "J8hOXG_ShowAllButton",
});
